import React from "react";
import Dropzone from "react-dropzone";
import ProductImage from "models/ProductImage";
import Image from "models/Image";
import ImageHelper from "helpers/Image";
import { Button } from "@headlessui/react";

export default class ImageUploadView extends React.Component {
  constructor(props) {
    super(props);

    this.inputFile = React.createRef();
    this.state = { init: 0, error: null, file: null };
    this.dragStartIndex = -1;
    this.dragEndIndex = -1;
    this.imageToDrag = false;
  }

  onClickEvent = (event) => {
    this.inputFile.current.click();
  };

  setDragging = (ev) => {
    ev.preventDefault();
    this.dragStartIndex = ev.currentTarget.dataset.index;
  };

  dragOverHandler = (ev) => {
    ev.preventDefault();
    if (this.dragStartIndex != ev.currentTarget.dataset.index) {
      ev.dataTransfer.dropEffect = "copy";
    }
    this.dragEndIndex = ev.currentTarget.dataset.index;
    return false;
  };

  dragLeaveHandler = (ev) => {
    ev.preventDefault();
    this.dragEndIndex = -1;
  };

  dropHandler = (ev) => {
    const { files } = this.state;

    if (this.dragStartIndex == this.dragEndIndex || this.dragEndIndex == -1) {
      this.imageToDrag.draggable = false;
      return;
    }
    var fileToDrag = files[this.dragStartIndex];
    files.splice(this.dragStartIndex, 1);
    files.splice(this.dragEndIndex, 0, fileToDrag);
    this.setState({ files: files });
    const { onChange } = this.props;
    if (onChange) {
      onChange(files);
    }
  };

  removeImageHandler = (ev) => {
    const { files } = this.state;
    const { onChange } = this.props;
    ev.preventDefault();
    let removeIndex = ev.currentTarget.dataset.index;

    files[removeIndex].removeImage();
    if (files[removeIndex].id == 0) {
      files.splice(removeIndex, 1);
    }

    this.setState({ files: files });
    if (onChange) {
      onChange(files);
    }
  };

  onStartDragHandler = (ev) => {
    this.imageToDrag =
      ev.currentTarget.parentElement.parentElement.parentElement;
    this.imageToDrag.draggable = true;
  };

  async onChangeFile(event) {
    event.stopPropagation();
    event.preventDefault();

    let newFile = event.target.files[0];
    let orgFile = newFile;

    const reader = new FileReader();
    reader.onloadend = async () => {
      let newImage = await ImageHelper.resizeImage(
        newFile,
        reader.result,
        800,
        800
      );
      let { init, file } = this.state;
      let { image } = this.props;

      if (!file) {
        file = image;
      }

      file.newImage(newImage);

      this.setState({ init: init + 1, file: file });
      const { onChange } = this.props;
      if (onChange) {
        onChange({ name: "image", value: file });
      }
    };
    reader.readAsDataURL(newFile);
  }

  renderUploadButton() {
    const { lbl } = this.props;
    return (
      <div className="flex col-span-full gap-x-8 items-center" key="-1">
        <div className="flex flex-none justify-center items-center bg-gray-200 size-24">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="text-gray-400 size-10"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
            <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-13zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54A.505.505 0 0 1 1 12.5v-9a.5.5 0 0 1 .5-.5h13z" />
          </svg>
        </div>
        <div>
          <Button
            type="button"
            className="btn-primary"
            onClick={this.onClickEvent}
          >
            Profielfoto aanpassen
          </Button>
          <p className="mt-2 text-gray-500 text-xs/5">
            JPG, GIF or PNG. 1MB max.
          </p>
          <input
            id="file-upload"
            type="file"
            className="sr-only"
            ref={this.inputFile}
            onChange={this.onChangeFile.bind(this)}
          />
        </div>
      </div>
    );
  }

  renderImageElement(image, index) {
    return (
      <div className="flex col-span-full gap-x-8 items-center" key={index}>
        <img
          src={image.getImage()}
          className="object-cover flex-none bg-gray-800 ring-1 ring-gray-200 size-24"
          alt="Profile avatar"
        />
        <div>
          <Button
            type="button"
            className="btn-primary"
            onClick={this.onClickEvent}
          >
            Profielfoto aanpassen
          </Button>
          <p className="mt-2 text-gray-500 text-xs/5">
            JPG, GIF or PNG. 1MB max.
          </p>
          <input
            type="file"
            className="sr-only"
            ref={this.inputFile}
            onChange={this.onChangeFile.bind(this)}
          />
        </div>
      </div>
    );
  }

  componentDidUpdate(prevProps) {
    const { image } = this.props;
    const { file } = this.state;
    if (file == null && image && prevProps !== this.props) {
      this.setState({ file: image });
    }
  }

  render() {
    const { file } = this.state;
    const { image } = this.props;
    let returnHtml = this.renderUploadButton();

    if (file && file.getImage() !== "") {
      returnHtml = this.renderImageElement(file, 0);
    } else if (image && image.getImage() !== "") {
      returnHtml = this.renderImageElement(image, 0);
    }

    return returnHtml;
  }
}

ImageUploadView.defaultProps = {
  image: null,
  lbl: "Upload hier je afbeelding",
};
